import MasterService from "./MasterService";

const FinancierService = {
    ...MasterService,

    getFianciersListing(params: object) {        
        return this.post('/financiers/getFinanciers', params);
    },

    addFinancier(params: object): Promise<any> {
        return this.post('/financiers/addFinancier', params)
    }
}

export default FinancierService;